// extracted by mini-css-extract-plugin
export default {"item":"Item_item__kiYdA","itemIcon":"Item_itemIcon__eHCBc","itemText":"Item_itemText__QcLWL","isHoveredItem":"Item_isHoveredItem__iX84i"};